import ReactMounter from 'lib/ReactMounter'
import TeamPage from 'pages/TeamPage/TeamPage'

ReactMounter.registerComponentToMountOnLoad('TeamPage', TeamPage)
